import React from 'react';
import ProductBagIconButton from "./ProductBagIconButton";
import {useSelector} from "react-redux";

const CompareButton = () => {
    const {products, url} = useSelector((state) => state.comparisonProducts);
    const translation = useSelector((state) => state.navigation.translations);
    const compare = translation?.compare ?? 'Compare';

    return (
        <ProductBagIconButton quantity={products.length} text={compare} icon='compare' href={url} active={products.length > 0}/>
    );
}

export default CompareButton;
